import type { User } from '@/types/auth';
import { hasPermission, Permission } from './permissions';

export const hasExceptionalRefundAccess = (
  user: User | null | undefined,
): boolean => hasPermission(user, Permission.REFUND_REQUESTS_READ);
